import React, {FunctionComponent, Suspense, useEffect, useState} from 'react';
import Button from 'components/button/Button';
import superHostIcon from 'assets/svg/superhost-subscription.svg';
import hostControlCheck from 'assets/svg/host-control-check.svg';
import sendInviteTicker from 'assets/svg/send-invite-ticker.svg';
import Styles from 'views/subscription/Subscription.module.scss';
import CustomModal from 'components/customModal/CustomModal';
import InputField from 'components/textField/InputField';
import TextArea from 'components/textArea/TextArea';
import { Subscription, CardList } from 'modules/types/types';
const Stripe = React.lazy(() => import('views/Stripe/Stripe'));

const SUPER_HOST_BENEFITS = [
  'Highlighted Super Host Profile',
  'Create highlighted chat rooms for special topics',
  'Enhanced notifications sent to all users of Moderate Politics',
];

interface SubscriptionProps {
  getSubscriptionRequest: Function;
  getCardRequest: Function;
  subscriptions: Subscription;
  card: CardList;
  loading: boolean;
  unSubLoading: boolean;
  unsubscribe: Function;
  unsubscribeStatus: string;
  feedBackRequest: Function;
  feedBackLoading: boolean;
  feedBackResponse: string;
}
const Subscriptions: FunctionComponent<SubscriptionProps> = (props: SubscriptionProps) => {
  const {
    getSubscriptionRequest,
    getCardRequest,
    subscriptions,
    card,
    loading,
    unSubLoading,
    unsubscribe,
    unsubscribeStatus,
    feedBackRequest,
    feedBackLoading,
    feedBackResponse,
  } = props;
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [subscription, setSubscription] = useState<Subscription>();
  const [unsubscriptionStatus, setUnsubscriptionStatus] = useState('');
  const user = JSON.parse(localStorage.getItem('user') as string);
  const [contactName, setContactName] = useState<string>(user?.name || '');
  const [contactEmail, setContactEmail] = useState<string>(user?.email || '');
  const [contactMessage, setContactMessage] = useState<string>('');
  const [contactDisabled, setContactDisabled] = useState<boolean>(true);
  const [showContactResponse, setShowContactResponse] = useState<boolean>(false);

  useEffect(() => {}, [user]);

  const subscriptionPopUp = () => {
    document.body.classList.add('modal-open');
    return (
      <div className="text-center">
        <p className="fontSixteen font-weight-normal text-black my-4">
          Proceed to payment to complete your
          <br />
          transaction.
        </p>
        <Button label="PROCEED TO PAYMENT MERCHANT" clickHandler={handlePaymentMerchant} />
        <div
          className="fontSixteen text-blue font-weight-600 text-uppercase mt-3"
          onClick={closeDialog}
          onKeyPress={closeDialog}
          role="button"
          tabIndex={0}
        >
          Close
        </div>
      </div>
    );
  };

  const closeDialog = () => {
    document.body.classList.remove('modal-open');
    setShowSubscribe(false);
    setPaymentPopUp(false);
    setUnsubscriptionStatus('');
  };

  const handlePaymentMerchant = () => {
    setShowSubscribe(false);
    setPaymentPopUp(true);
  };

  const stripePaymentModal = () => {
    document.body.classList.add('modal-open');
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Stripe type="subscribe" planId='' card={card} subscription={subscription} closeDialog={closeDialog} />
      </Suspense>
    );
  };

  const handleUnsubscribe = () => {
    unsubscribe({});
  };

  const handleContactSubmit = () => {
    feedBackRequest({
      name: contactName || user?.name,
      email: contactEmail || user?.email,
      message: `[Super Host inquiry] ${contactMessage}`,
    });
  };

  useEffect(() => {
    getSubscriptionRequest({});
  }, []);

  useEffect(() => {
    getCardRequest({});
  }, []);

  useEffect(() => {
    setSubscription(subscriptions);
  }, [subscriptions]);

  useEffect(() => {}, [card]);

  useEffect(() => {
    setUnsubscriptionStatus(unsubscribeStatus);
  }, [unsubscribeStatus]);

  useEffect(() => {
    setContactDisabled(contactMessage.trim() === '');
  }, [contactMessage]);

  useEffect(() => {
    if (feedBackResponse !== '') {
      setShowContactResponse(true);
      setContactMessage('');
      const timer = window.setTimeout(() => {
        setShowContactResponse(false);
      }, 5000);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [feedBackResponse]);

  const isSuperHost = Boolean(user?.is_super_host);

  return (
    <>
      <div className={Styles.settingsContent}>
        <div className={Styles.pageCard}>
          <div className={Styles.heroSection}>
            <img src={superHostIcon} className={Styles.superHostImage} alt="super host icon" />
            <h2 className={Styles.heroTitle}>
              {isSuperHost ? 'You are a Super Host!' : 'Contact us to be a Super Host'}
            </h2>
            <ul className={`list-unstyled ${Styles.listingWrapper}`}>
              {SUPER_HOST_BENEFITS.map((benefit) => (
                <li key={benefit} className={Styles.listingItem}>
                  <img
                    src={hostControlCheck}
                    alt=""
                    className={Styles.listingCheck}
                    aria-hidden="true"
                  />
                  {benefit}
                </li>
              ))}
            </ul>
            {/* Subscribe / Unsubscribe hidden — logic kept for future self-serve subscription
            {user && user.is_super_host ? (
              <>
                <Button showLoading={unSubLoading} cssClass="mt-4 unsubscribe" label="UNSUBSCRIBE" clickHandler={handleUnsubscribe} />
                {unsubscribeStatus && <p>{unsubscriptionStatus}</p>}
              </>
            ) : (
              <Button cssClass="mt-4" label="SUBSCRIBE FOR $10 A MONTH" clickHandler={() => setShowSubscribe(true)} />
            )}
            */}
          </div>

          {!isSuperHost && (
            <div className={Styles.wrapper}>
              <h4 className={Styles.contactFormHeading}>Super Host contact form</h4>
              <p className={`mb-0 ${Styles.contactFormDetail}`}>
                Interested in becoming a Super Host? Send us a message and we will get back to you.
              </p>
              <div className={`mb-0 ${Styles.formWrapper}`}>
                <div className="form-group">
                  <InputField
                    cssClass={Styles.contactInput}
                    type="text"
                    value={contactName}
                    placeholder="Name"
                    isDisable
                  />
                </div>
                <div className="form-group">
                  <InputField
                    cssClass={Styles.contactInput}
                    type="email"
                    value={contactEmail}
                    placeholder="Email"
                    isDisable
                  />
                </div>
                <div className="form-group">
                  <TextArea
                    placeholder="Type your message here..."
                    handleValue={setContactMessage}
                    cssClass={Styles.contactMessage}
                  />
                  {showContactResponse && (
                    <p className={Styles.formSuccess}>{feedBackResponse}</p>
                  )}
                </div>
              </div>
              <div className={`text-center ${Styles.sendButton}`}>
                <Button
                  label="SEND"
                  cssClass={Styles.sendContactPageBtn}
                  showLoading={feedBackLoading}
                  clickHandler={handleContactSubmit}
                  disabled={contactDisabled}
                  image
                  src={sendInviteTicker}
                  alt=""
                  imageClass={Styles.sendContactTicker}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {showSubscribe && (
        <CustomModal
          title="You’re getting a Super Host Subscription. Nice!"
          wrapperClass={Styles.subscriptionWrapper}
          closeDialog={closeDialog}
        >
          {subscriptionPopUp()}
        </CustomModal>
      )}
      {paymentPopUp && (
        <CustomModal closeDialog={closeDialog} title="Subscribe" wrapperClass={Styles.rechargeAccountWrapper}>
          {stripePaymentModal()}
        </CustomModal>
      )}

    </>
  );
};

export default Subscriptions;
